import { WorkBook } from 'xlsx';

export interface IFinStatementFile {
    versionName: string;
    file: ISpreadSheet;
}
export interface ISpreadSheet {
    sheets: ISheet[];
}

export interface ISheet {
    /** representing a sparse array */
    rows: (ISheetRow | undefined)[];
    name: string;
    rawWorkbook: WorkBook;
}

export interface ISheetRow {
    /** representing a sparse array */
    cells: string[];
}
